<div class="outline light-primary-border-color">
  <div class="header">Create Account</div>

  <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
    <div class="form-group">
      <label for="email">Email</label>
      <input
        type="text"
        class="form-control"
        id="register-email"
        name="email"
        formControlName="email"
      />
    </div>

    <div class="form-group">
      <label for="password">Password</label>
      <span class="subtext">should be at least 6 characters</span>
      <input
        type="password"
        class="form-control"
        id="register-password"
        name="password"
        formControlName="pass1"
      />
    </div>
    <div class="form-group">
      <label for="password">Re-type Password</label>
      <input
        type="password"
        class="form-control"
        id="register-retype-password"
        name="password"
        formControlName="pass2"
      />
    </div>
    <div class="form-group">
      <button
        [disabled]="registerForm.invalid"
        class="pv-button"
        [ngClass]="{ disabled: registerForm.invalid }"
      >
        Create Account
      </button>
    </div>
    <div class="error-message warn-color">{{ errorMessage }}</div>
  </form>
</div>